import { CheckoutAvailabilityService } from '@inter-ikea-kompis/services';
import { formatProductForRetailUnit } from '../components/ProductList/utils';
import config from '../config';
export const getStoreAvailabilities = async (products, storeId, serviceSettings) => {
    const service = new CheckoutAvailabilityService({
        settings: serviceSettings,
        dexfApiKey: config.dexfApiKey
    });
    const itemsForRetailUnit = products
        .map(product => formatProductForRetailUnit(product))
        .filter(Boolean);
    try {
        return await service.getStoreAvailabilities(`${storeId}`, itemsForRetailUnit);
    }
    catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
    }
};
//# sourceMappingURL=getStoreAvailabilities.js.map